<template>
    <!-- 广告列表 -->
    <div>
      <!-- 筛选查询 -->
      <div class="wScreenArea">
        <el-card class="box-card">
          <div class="wScreenCardHeader">
            <span></span>
            <el-button type="primary" size="mini" @click="show = true"
              >添加</el-button
            >
          </div>
        </el-card>
      </div>
      <!-- 新增、修改版banner弹框 -->
      <el-dialog
        width="1000px"
        :title="advertisementForm.id ? '修改首页广告' : '添加首页广告'"
        :visible.sync="show"
        :append-to-body="true"
        :close-on-click-modal="false"
      >
        <!-- 表单 -->
        <el-form
          :rules="rulesAdvertisementForm"
          :model="advertisementForm"
          ref="advertisementForm"
          label-width="120px"
          @submit.native.prevent
        >
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="广告名称" prop="adName">
                <el-input
                  v-model="advertisementForm.adName"
                  type="text"
                  placeholder="请输入广告名称"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="广告描述" prop="description">
                <el-input
                  v-model="advertisementForm.description"
                  type="textarea"
                  placeholder="请输入广告描述"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="展示时间">
                <el-input-number
                  v-model="advertisementForm.showTime"
                  :min="1"
                  :max="10"
                  label="展示时间"
                  style="width: 100%"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品名称" prop="goodsId">
                <el-input
                  v-model="selectedGoodsText"
                  placeholder="请选择商品"
                  disabled
                ></el-input>
                <div class="ad-goods-selector__actions">
                  <el-button type="primary" size="small" @click="openGoodsSelector">选择商品</el-button>
                  <el-button size="small" @click="clearSelectedGoods" :disabled="!advertisementForm.goodsId">清空</el-button>
                </div>
                <div class="ad-goods-selector__tip">
                  <span>可按店铺、商品名筛选要跳转的菜品</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
    
          <el-row :gutter="24">
            <el-col :span="12">
             
              <el-form-item label="广告内容" prop="adUri">
                <el-upload ref="mainUpload" list-type="picture-card" :limit="limitMainImg" :file-list="mainFileList"
                  :class="{ hide: hideMainUpload }" :action="getUploadUri()" :before-upload="uploadBefore"
                  :on-success="uploadSuccessMain" :on-remove="uploadRemoveMain" :show-file-list="true">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
  
            </el-col>
          </el-row>
          <el-row :gutter="24">
        
            <el-col :span="12">
              <el-form-item
          label="是否启用："
          prop="ban"
        >
  <el-switch
    v-model="advertisementForm.bannedFlag"
    active-color="#ff4949"
    inactive-color="#DCDFE6"
    active-value="0"
    inactive-value="1">
  </el-switch>
        </el-form-item>
            </el-col>
          </el-row>
         
    
        </el-form>
        <!-- footer -->
        <div slot="footer">
          <el-button @click="show = false">取 消</el-button>
          <el-button type="primary" @click="submitCoupon('advertisementForm')">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="1200px"
        title="选择跳转商品"
        :visible.sync="goodsSelectorVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
      >
        <el-form :inline="true" :model="goodsSelectorForm" class="goods-selector-form">
          <el-form-item label="店铺名称">
            <el-select
              v-model="goodsSelectorForm.storeId"
              placeholder="全部店铺"
              filterable
              clearable
              @change="searchGoodsSelector"
            >
              <el-option
                v-for="item in selectorStoreOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="模糊查询">
            <el-input
              v-model="goodsSelectorForm.search"
              placeholder="请输入商品名称"
              clearable
              @keyup.enter.native="searchGoodsSelector"
              @clear="searchGoodsSelector"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchGoodsSelector">查询</el-button>
            <el-button @click="resetGoodsSelector">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="goods-selector-toolbar">
          <span v-if="advertisementForm.goodsId">当前已选商品：{{ selectedGoodsText }}</span>
        </div>
        <el-table
          :data="goodsSelectorList"
          border
          v-loading="goodsSelectorLoading"
          :row-class-name="goodsSelectorRowClassName"
        >
          <el-table-column prop="name" label="商品名称" min-width="180"></el-table-column>
          <el-table-column label="店铺名称" min-width="180">
            <template slot-scope="scope">
              {{ getStoreName(scope.row.storeId) }}
            </template>
          </el-table-column>
          <el-table-column prop="retailPrice" label="价格" width="100"></el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              {{ scope.row.state === 1 ? "上架" : "下架" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="selectGoods(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="goods-selector-pagination">
          <el-pagination
            @size-change="handleGoodsSelectorSizeChange"
            @current-change="handleGoodsSelectorCurrentChange"
            :current-page="goodsSelectorPagination.current"
            :page-sizes="goodsSelectorPagination.sizes"
            :page-size="goodsSelectorPagination.size"
            :total="goodsSelectorPagination.total"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </el-dialog>
      <!-- 表格数据 -->
      <div class="wTableArea">
        <!-- 订单列表 -->
        <template>
          <!-- 表格 -->
          <el-table border :data="advertisementList">
            <el-table-column
              prop="adName"
              label="广告名称"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column label="图片" align="center">
              <template slot-scope="scope">
                <el-image
                  style="width: 180px; height: 100px"
                  fit="cover"
                  :src="scope.row.adUri"
                  :preview-src-list="[scope.row.adUri]"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column
            prop="description"
            label="描述"
            align="center"
            width="100"
          >
          </el-table-column>
            <el-table-column
              prop="goodsName"
              label="商品名称"
              align="center"
              width="100"
            >
            </el-table-column>
           
            <el-table-column prop="isUsed" label="状态" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.bannedFlag == 1">禁用</div>
                <div v-else-if="scope.row.bannedFlag == 0">启用</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="editCoupon(scope)"
                  ><span>编辑</span></el-button
                >
                <el-button
                  type="text"
                  @click="delCoupon(scope.row.id)"
                  ><span>删除</span></el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
        <!-- 分页 -->
        <div class="wPagination" >
          <div class="wPagination">
            <el-pagination
               @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
              :current-page="pagination.current"
              :page-sizes="pagination.sizes"
              :page-size="pagination.size"
              :total="pagination.total"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 分页 -->
    </div>
  </template>
  
  <script>
  import {
    getAllAdvertisementApi,
    addAdvertisementApi,
    delAdvertisementApi,
    putAdvertisementApi
  } from "@/network/api";
  
  export default {
    name: "OperateAdvertisement",
    data() {
      return {
        advertisementList: [],
        advertisementForm: {
          id: null,
          adName: "",
          description: "",
          showTime: 1,
          bannedFlag: '0',
          goodsId: null,
          adUri: null,
        },
        selectedGoodsInfo: {
          id: null,
          name: "",
          storeId: null,
          categoryId: null,
        },
        goodsSelectorVisible: false,
        goodsSelectorLoading: false,
        goodsSelectorForm: {
          storeId: null,
          search: "",
        },
        allGoodsSelectorList: [],
        goodsSelectorList: [],
        goodsSelectorPagination: {
          current: 1,
          size: 10,
          sizes: [10, 20, 50],
          total: 0,
        },
        selectorStoreOptions: [],
        mainFileList: [],         // 主图
        limitMainImg: 1,          // 上传数量限制
        hideMainUpload: false,    // 是否隐藏上传按钮
        show: false, //是否展示
        // 分页配置
        pagination: {
          current: 1,
          size: 20,
          sizes: [10, 20, 50, 100],
          total: 0,
        },
        rulesAdvertisementForm: {
          adName: [
            { required: true, message: "请输入广告名称", trigger: "blur" },
          ],
          adUri: [
            { required: true, message: "请上传广告图片", trigger: "blur" },
          ],
          goodsId: [
            { required: true, message: "请选择商品", trigger: "change" },
          ],
        },
      };
    },
    mounted() {
      this.getAllAdvertisement();
      this.getSelectorStoreOptions();
    },
    computed: {
      selectedGoodsText() {
        if (!this.selectedGoodsInfo.id) {
          return "";
        }
        const textList = [this.selectedGoodsInfo.name];
        const storeName = this.getStoreName(this.selectedGoodsInfo.storeId);
        if (storeName) {
          textList.push(storeName);
        }
        return textList.join(" / ");
      },
    },
    methods: {
      //获取商品广告
      getAllAdvertisement() {
        getAllAdvertisementApi({pageModel:{pageNo:this.pagination.current, pageSize:this.pagination.size}}).then(
          (res) => {
            this.advertisementList = res.records;
            this.pagination.total = res.total;
          }
        );
      },
      getSelectorStoreOptions() {
        this.$api.store_list({
          data: {
            "pageModel.pageNo": 1,
            "pageModel.pageSize": 2000,
            goodType: 1,
          },
          success: (res) => {
            const records = res && res.records ? res.records : [];
            this.selectorStoreOptions = records.map((item) => ({
              label: item.storeName,
              value: item.id,
            }));
          },
        });
      },
      openGoodsSelector() {
        this.goodsSelectorVisible = true;
        this.goodsSelectorPagination.current = 1;
        this.fetchGoodsSelectorSourceList();
      },
      fetchGoodsSelectorSourceList() {
        this.goodsSelectorLoading = true;
        
        let data = {
          "pageModel.pageNo": this.goodsSelectorPagination.current,
          "pageModel.pageSize": this.goodsSelectorPagination.size,
          state: 1,
          goodType: 1
        };
        if (this.goodsSelectorForm.storeId) {
          data.storeId = this.goodsSelectorForm.storeId;
        }
        if (this.goodsSelectorForm.search) {
          data.search = this.goodsSelectorForm.search;
        }

        this.$api.goods_GCList({
          data: data,
          success: (res) => {
            this.goodsSelectorList = res.records || [];
            this.goodsSelectorPagination.total = res.total || 0;
            this.goodsSelectorLoading = false;
          }
        });
      },
      searchGoodsSelector() {
        this.goodsSelectorPagination.current = 1;
        this.fetchGoodsSelectorSourceList();
      },
      resetGoodsSelector() {
        this.goodsSelectorForm = {
          storeId: null,
          search: "",
        };
        this.goodsSelectorPagination.current = 1;
        this.fetchGoodsSelectorSourceList();
      },
      handleGoodsSelectorSizeChange(val) {
        this.goodsSelectorPagination.size = val;
        this.goodsSelectorPagination.current = 1;
        this.fetchGoodsSelectorSourceList();
      },
      handleGoodsSelectorCurrentChange(val) {
        this.goodsSelectorPagination.current = val;
        this.fetchGoodsSelectorSourceList();
      },
      selectGoods(row) {
        this.advertisementForm.goodsId = row.id;
        this.selectedGoodsInfo = {
          id: row.id,
          name: row.name,
          storeId: row.storeId,
          categoryId: row.categoryId,
        };
        this.goodsSelectorVisible = false;
      },
      clearSelectedGoods() {
        this.advertisementForm.goodsId = null;
        this.selectedGoodsInfo = {
          id: null,
          name: "",
          storeId: null,
          categoryId: null,
        };
      },
      getStoreName(storeId) {
        const currentStore = this.selectorStoreOptions.find((item) => item.value === storeId);
        return currentStore ? currentStore.label : "";
      },
      goodsSelectorRowClassName({ row }) {
        return row.id === this.advertisementForm.goodsId ? "goods-selector-row--active" : "";
      },
      //删除广告
      delCoupon(id){
        this.$confirm("此操作将永久删除该广告, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            delAdvertisementApi(id).then(res=>{
              this.$message.success("删除成功!");
          this.getAllAdvertisement()
        })
            .catch(err => {});
          })
      
        
      },
      //编辑广告
      editCoupon(scope){
        this.advertisementForm=JSON.parse(JSON.stringify(scope.row))
        this.mainFileList = this.advertisementForm.adUri ? [{url:this.advertisementForm.adUri}] : []
         this.advertisementForm.bannedFlag=this.advertisementForm.bannedFlag+""
         if (this.advertisementForm.goodsId && scope.row.goodsName) {
          this.selectedGoodsInfo = {
            id: this.advertisementForm.goodsId,
            name: scope.row.goodsName,
            storeId: scope.row.storeId || null,
            categoryId: scope.row.categoryId || null,
          };
         } else {
          this.clearSelectedGoods();
         }
       
         this.hideMainUpload=true
        this.show=true
      },
        /**
       * 文件上传
      */
      getUploadUri() { return `${process.env.VUE_APP_URE}/file/uploadFile` },
      // 上传之前的钩子
      uploadBefore(file) {
        this.loading = true
        const isJPG = file.type === 'image/jpeg'
        const isPNG = file.type === 'image/png'
        if (!isJPG && !isPNG) {
          this.$message.error('上传图片只能是 JPG 或者 PNG 格式!')
        }
        return isJPG || isPNG
      },
      // 上传成功回调
      uploadSuccessMain(file, fileList) {
        let obj = { url: file.data }
        this.mainFileList.push(obj)           // push已经上传的图片
        this.advertisementForm.adUri = file.data
        if (this.mainFileList.length >= this.limitMainImg) {
          this.hideMainUpload = true          // 隐藏上传按钮
        }
        this.$refs.mainUpload.clearFiles()    // 清空上传的文件列表
      },
     
      // 移除文件
      uploadRemoveMain(file) {
        console.log(file)
        for (let i = 0; i < this.mainFileList.length; i++) {
          if (this.mainFileList[i].url == file.url) {
            this.mainFileList.splice(i, 1)
            this.advertisementForm.adUri = null
            this.hideMainUpload = false
          }
        }
      },
      submitCoupon(advertisementForm){
        this.$refs[advertisementForm].validate(valid=>{
          if (valid) {
            if (!this.advertisementForm.id) {
                addAdvertisementApi(this.advertisementForm).then(res=>{
               
                  this.getAllAdvertisement()
                this.show=false
                this.$message.success("添加成功!");
              })
    
        }else{
          putAdvertisementApi(this.advertisementForm).then(res=>{
            console.log(res);
              this.getAllAdvertisement()
              this.show=false
              this.$message.success("修改成功!");
            })
          }
       
          }
         
        })
       
      },
      handleSizeChange(val){
        this.pagination.size=val
      },
      handleCurrentChange(val){
    this.pagination.current=val
      }
    },
    watch: {
      pagination: {
        handler() {
          console.log(222);
          this.getAllAdvertisement();
        },
        immediate: true,
        deep: true,
      },
      show(newVal) {
        if (!newVal) {
          this.advertisementForm = {
            id: null,
            adName: "",
            description: "",
            showTime: 1,
            atype: "",
            bannedFlag: '0',
            goodsId: null,
            adUri: null,
          };
          this.mainFileList=[]
          this.hideMainUpload=false
          this.clearSelectedGoods()
          this.goodsSelectorVisible = false
          this.goodsSelectorForm = {
            storeId: null,
          };
          this.allGoodsSelectorList = []
          this.goodsSelectorList = []
          this.goodsSelectorPagination.current = 1
          this.goodsSelectorPagination.total = 0
          this.goodsType = []
        }
      },
    },
  };
  </script>
  
  <style lang="less">
  @import "@/assets/css/publicStyle.less";
  
  .hide .el-upload--picture-card {
    display: none !important;
  }

  .ad-goods-selector {
    width: 100%;
  }

  .ad-goods-selector__actions {
    margin-top: 8px;
  }

  .ad-goods-selector__tip {
    margin-top: 6px;
    color: #999999;
    line-height: 1.4;
  }

  .goods-selector-form {
    margin-bottom: 12px;
  }

  .goods-selector-toolbar {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    color: #666666;
  }

  .goods-selector-pagination {
    margin-top: 16px;
    text-align: right;
  }

  .el-table .goods-selector-row--active {
    background-color: #fdf6ec;
  }
  
  .wML-screen {
    display: block;
    width: 100%;
    user-select: none;
    margin-bottom: 20px;
  
    // 筛选列表
    .wMLS-list {
      display: block;
      width: 100%;
    }
  }
  
  // 商品列表区域
  .wGoodsList-area {
    display: block;
    width: 100%;
    padding: 20px 16px;
    box-sizing: border-box;
    background-color: #ffffff;
  
    // 商品类别
    .wGL-categoryArea {
      display: flex;
      justify-content: space-between;
  
      .wGL-category {
        flex: none;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        user-select: none;
        margin-bottom: 15px;
  
        .wGLC-item {
          flex: none;
          height: 40px;
          line-height: 40px;
          padding: 0 20px;
          margin-right: 10px;
          box-sizing: border-box;
          background-color: #f3f3f3;
          // border: 1px solid #999999;
          font-size: @wFontSize;
          cursor: pointer;
          transition: all 0.3s;
  
          &:hover,
          &.wActive {
            background-color: @wColor_theme;
            border-color: @wColor_theme;
            color: #ffffff;
          }
        }
      }
    }
  
    // 商品状态
    .wGL-state {
      display: flex;
      justify-content: space-between;
      align-items: center;
      user-select: none;
      margin-bottom: 15px;
  
      .wGLS-category {
        flex: none;
        display: flex;
        align-items: center;
  
        .wGLSC-btn {
          flex: none;
          margin-right: 15px;
          cursor: pointer;
          transition: all 0.3s;
          font-size: @wFontSize;
          color: #333333;
  
          &:hover,
          &.wActive {
            color: @wColor_theme;
            transition: all 0.3s;
          }
        }
      }
  
      .wGLS-operate {
        flex: none;
        display: flex;
        align-items: center;
  
        .wGLSO-btn {
          flex: none;
          margin-right: 7px;
          cursor: pointer;
          transition: all 0.3s;
          font-size: @wFontSize;
          color: #333333;
  
          &:hover {
            color: @wColor_theme;
            transition: all 0.3s;
          }
        }
      }
    }
  
    // 数据列表
    .wGL-goods {
      display: block;
      width: 100%;
  
      // table表
      .wGLG-table {
        display: block;
        width: 100%;
      }
  
      // 分页
      .wGLG-page {
        display: block;
        width: 100%;
        margin-top: 20px;
        text-align: center;
      }
    }
  }
  
  // 职务信息表单
  .wDialogForm {
    display: block;
    width: 100%;
    height: 500px;
    position: relative;
  
    .wDialogForm-box {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }
  }
  
  .specification {
    .el-form-item__content {
      display: flex !important;
    }
  }
  </style>
  
